<template>
  <v-main>
    <v-snackbar v-model="snackbar" timeout="3000" :color="snackbarValue.color" style="top:0;">
      {{ snackbarValue.message }}
    </v-snackbar>
    <header-components></header-components>
    <title-components title="陽性確定診断 証明書"></title-components>
    <v-container
      class="mx-auto"
      style="max-width: 900px;"
    >
      <v-form ref="form" class="mt-5">
        <v-row no-gutters justify="center" class="mx-5 mb-5">
          <v-text-field
            label="診察ID"
            append-icon="mdi-update"
            variant="underlined"
            @click:append="updateName"
            @blur="updateName"
            :rules="[required]"
            :error-messages="existUserErrors"
            v-model="certificate.id"
            type="text"
            placeholder="例) 110-1"
          ></v-text-field>
        </v-row>
        <v-row no-gutters justify="center" class="mx-5 mb-5" >
          <v-text-field
            label="患者氏名"
            v-model="certificate.name"
            filled
            readonly
          ></v-text-field>
        </v-row>
        <v-row no-gutters justify="center" class="mx-5">
          <v-text-field
            label="診断日"
            :rules="[required, dateValidate]"
            v-model="certificate.diagnosisDate"
            variant="underlined"
            type="date"
            :max="maxDay"
          ></v-text-field>
        </v-row>
        <v-row justify="center" align-content="center" class="mt-15">
          <v-btn
            dark
            x-large min-width="200px"
            color="doorAccentColor"
            class="mx-4 mb-10"
            @click="showRegisterDialog"
          >登録
          </v-btn>
        </v-row>
      </v-form>
    </v-container>
    <footer-components></footer-components>
    <v-dialog
      v-model="showModal"
      width="350"
    >
      <v-card>
        <v-card-title class="bg-doorMainColor">確認</v-card-title>
        <v-card-text>
          <div>以下の内容で陽性確定診断証明書を登録しますか？</div>
        </v-card-text>
        <v-card-text class="text-center">
          <div>診察ID: {{ certificate.id }}</div>
          <div>患者氏名: {{ certificate.name }}</div>
          <div>診断日: {{ certificate.diagnosisDate }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-spacer></v-spacer>
        <v-row justify="center" align-content="center" class="my-3">
          <v-btn
            dark
            x-large min-width="200px"
            color="success"
            class="mb-4 mx-4 white--text"
            @click="register"
            :loading="isLoading"
          >登録
          </v-btn>
          <v-btn
            dark
            :disabled="isLoading"
            color="#B0B6BA"
            x-large min-width="200px" class="mb-4 mx-4"
            @click="showModal = false"
          >キャンセル
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import { defineComponent, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import HeaderComponents from '@/components/InterviewHeader.vue';
import FooterComponents from '@/components/InterviewFooter.vue';
import TitleComponents from '@/components/BasicTitle.vue';
import { useFormValidator } from '@/func/useFormValidator';
import { format } from 'date-fns'
import { Logger } from 'aws-amplify';

const logger = new Logger('AdminCovidCertificate');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents
  },
   setup() {
    logger.info('AdminCovidCertificate')
    const { required, dateValidate } = useFormValidator();

    const form = ref(null)
    const maxDay = ref(new Date().toISOString().substring(0,10));
    const existUserErrors = ref([])
    const certificate = reactive({
      id: '',
      name: '',
      diagnosisDate: format(Date.now(), 'yyyy-MM-dd')
    })

    const store = useStore();
    const showModal = ref(false);
    const updateName = async () => {
      logger.info('name update');
      if (certificate.id === '' || certificate.id === null) {
        certificate.name = '';
        existUserErrors.value = ['入力してください。']
        return;
      }
      try {
        const result = await store.dispatch('advanceInterview/getInterviewsByTreatmentSerialNumber', { id: certificate.id })
        if (result === null || result.items.length === 0) {
          certificate.name = '';
          existUserErrors.value = ['診察IDに紐付くユーザーが存在しません。']
          return
        }
        existUserErrors.value = [];
        const userInfo = JSON.parse(result.items[0].userInfo);
        certificate.name = userInfo.name
      } catch(e) {
        existUserErrors.value = ['名前の取得中にエラーが発生しました。']
        logger.error(e)
      }
    }
    //登録ダイヤログ表示
    const showRegisterDialog = async () => {
      // カーソルを外さずにダイヤログ表示した場合の対策
      await updateName()
      const result = await form.value.validate();
      if (!result.valid || existUserErrors.value.length > 0) {
        return;
      }
      showModal.value = true;
    }
    //登録実行処理
    const snackbar = ref(false);
    const isLoading = ref(false);
    const snackbarValue = reactive({
      color: "",
      message: ""
    });

    const register = async () => {
      logger.info('TOTO Execute Register API');
      isLoading.value = true;
      try {
        await store.dispatch('covidCertificate/register', {
          treatmentSerialNumber: certificate.id,
          diagnosedAt: certificate.diagnosisDate
        });
        successFlow();
      } catch(e) {
        logger.error(e.response);
        errorFlow();
      }
    }

    const errorFlow = () => {
      snackbar.value = true;
      snackbarValue.color = 'error';
      snackbarValue.message = `エラーが発生しました。お手数ですが再度登録ボタン押してください。`
      showModal.value = false;
      isLoading.value = false;
    }

    const successFlow = () => {
      snackbar.value = true;
      snackbarValue.color = 'success';
      snackbarValue.message = `${certificate.id}の陽性確定診断証明書を登録しました。`
      showModal.value = false;
      isLoading.value = false;
      form.value.reset();
      certificate.diagnosisDate = format(Date.now(), 'yyyy-MM-dd');
    }

    return {
      certificate,
      showRegisterDialog,
      updateName,
      form,
      existUserErrors,
      required,
      dateValidate,
      showModal,
      snackbar,
      register,
      snackbarValue,
      maxDay,
      isLoading
    }
   }
})
</script>
